import { FC, useLayoutEffect, useState } from "react";

export const Stopwatch: FC = () => {
  const [value, setValue] = useState(0);

  useLayoutEffect(() => {
    const id = window.setInterval(() => {
      setValue((v) => v + 1);
    }, 1000);

    return () => window.clearInterval(id);
  }, []);

  if (value < 1) {
    return null;
  }

  return <>{value}</>;
};
